import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_FILTER_BRANCH_DESCRIPTION = registerQuery({
  fieldName: 'filterDescription',
  args: ['objectTypeId', 'uniqueId'],
  fetcher({
    objectTypeId,
    filterBranch
  }) {
    return http.post('automationplatform/v1/filter-descriptions/generate', {
      data: {
        objectTypeId,
        filterBranch
      }
    }).then(({
      description
    }) => description);
  }
});